import { Star } from "lucide-react";

export function Stars({ value, size = "h-4 w-4", testid }) {
  const v = value || 0;
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${v >= i - 0.25 ? "fill-[#D97706] text-[#D97706]" : v >= i - 0.75 ? "fill-[#FDE68A] text-[#D97706]" : "text-slate-300"}`} />
      ))}
    </span>
  );
}

export function RatingBlock({ b, compact }) {
  if (!b.rating) {
    return <span className="text-xs text-slate-500" data-testid="rating-none">Pas encore noté</span>;
  }
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
      <span className="inline-flex items-center gap-1.5">
        <span className="font-display text-lg font-bold" data-testid="rating-value">{b.rating.toFixed(1)}</span>
        <Stars value={b.rating} />
      </span>
      {!compact && (
        <span className="text-xs text-slate-500">
          {b.google_rating ? `Google ${b.google_rating.toFixed(1)} (${b.google_count || 0})` : ""}
          {b.google_rating && b.review_count ? " · " : ""}
          {b.review_count ? `Communauté ${b.review_avg?.toFixed(1)} (${b.review_count})` : ""}
        </span>
      )}
    </div>
  );
}
